import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setFormValue, validateForm } from 'redux/modules/newAffiliate';
import * as _ from 'lodash';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { Spinner, Tooltip } from 'components';
import * as styles from './NewAffiliate.scss';
var NewAffiliateFormStep1 = (_dec = connect(function (state) {
  return {
    savedBillingConfig: state.organization.orgBillingConfig,
    firstPass: state.newAffiliate.validation.firstPass,
    validationFields: state.newAffiliate.validationFields,
    invalidFields: state.newAffiliate.invalidFields,
    productsByOrgId: state.products.productsByOrgId,
    gettingProducts: state.products.gettingProducts,
    orgConfig: state.newAffiliate.orgConfig,
    orgDetails: state.newAffiliate.orgDetails,
    affiliateProductId: state.newAffiliate.affiliateConfig.affiliateProductId,
    whiteLabel: state.whiteLabel,
    theme: state.theme
  };
}, {
  setFormValue: setFormValue,
  validateForm: validateForm
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewAffiliateFormStep1, _Component);

  var _super = _createSuper(NewAffiliateFormStep1);

  function NewAffiliateFormStep1(props) {
    var _this;

    _classCallCheck(this, NewAffiliateFormStep1);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "generateErrorText", function (fieldName) {
      var errorText = ''; // only show error text after 'next' button has been clicked

      if (!_this.props.firstPass) {
        if (_this.props.validationFields.includes(fieldName)) {
          if (_this.props.invalidFields.includes(fieldName)) {
            errorText = 'Required field';
          }
        }
      }

      return errorText;
    });

    _defineProperty(_assertThisInitialized(_this), "handleTextFieldChange", function (e, val) {
      _this.props.setFormValue(e.target.id, 'orgDetails', val);
    });

    _defineProperty(_assertThisInitialized(_this), "renderProductLabel", function (product, index) {
      return /*#__PURE__*/React.createElement("div", null, product.title && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 17,
          borderBottom: '1px solid gray',
          paddingBottom: 4,
          marginBottom: 4
        }
      }, product.title), product.description && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15,
          fontStyle: 'italic',
          marginBottom: 4
        }
      }, product.description), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15
        }
      }, "Monthly Price: ", _this.formatCurrency(parseInt(product.retailMonthlyPrice, 10) + parseInt(product.adsBudget, 10))), parseInt(product.adsBudget, 10) !== 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 13,
          lineHeight: '16px',
          marginBottom: 4
        }
      }, "Includes ", _this.formatCurrency(product.adsBudget), "/mo ads budget."), parseInt(product.retailSetupFee, 10) !== 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15
        }
      }, "Setup Fee: ", _this.formatCurrency(product.retailSetupFee)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (label, fieldName, value, key) {
      var errorText = _this.generateErrorText(label);

      var displayText = _.startCase(label);

      if (_this.props.validationFields.includes(label)) {
        displayText += '*';
      }

      return /*#__PURE__*/React.createElement(TextField, {
        key: key,
        errorText: errorText,
        floatingLabelText: displayText,
        hintText: displayText,
        id: fieldName,
        value: value,
        onChange: _this.handleTextFieldChange,
        style: {
          marginRight: 8,
          marginLeft: 8,
          flex: '1 1 auto',
          minWidth: 155,
          width: 0
        }
      });
    });

    if (!_this.props.firstPass) {
      props.validateForm();
    }

    return _this;
  }
  /** *********************************************************
   CUSTOM METHODS
   ***********************************************************/


  _createClass(NewAffiliateFormStep1, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          edit = _this$props.edit;
      var partnerName = this.props.whiteLabel && this.props.whiteLabel.Organization ? this.props.whiteLabel.Organization.name : 'Partner';
      var newAffiliateName = this.props.orgDetails.businessName && this.props.orgDetails.businessName !== '' ? this.props.orgDetails.businessName : 'New Client';
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: 1
        }
      }, this.props.gettingProducts && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 12,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), !this.props.edit && /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.formSection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Select A Package"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "products",
        defaultSelected: this.props.affiliateProductId,
        onChange: function onChange(e, val) {
          _this2.props.setFormValue('affiliateProductId', 'affiliateConfig', val);
        }
      }, this.props.productsByOrgId[this.props.theme.org] && this.props.productsByOrgId[this.props.theme.org].map(function (product, index) {
        return /*#__PURE__*/React.createElement(RadioButton, {
          value: product.id,
          label: _this2.renderProductLabel(product, index),
          key: "productRadio_".concat(index),
          style: {
            marginBottom: 12
          }
        });
      }))))), /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.formSection,
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Client Details"), this.renderInput('firstName', 'firstName', this.props.orgDetails.firstName, 'firstName_textField'), this.renderInput('lastName', 'lastName', this.props.orgDetails.lastName, 'lastName_textField'), this.renderInput('email', 'email', this.props.orgDetails.email, 'email_textField'), this.renderInput('businessName', 'businessName', this.props.orgDetails.businessName, 'businessName_textField')), /*#__PURE__*/React.createElement("section", {
        className: styles.formSection,
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Payment Details"), /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "whoentersCC",
        defaultSelected: this.props.orgDetails.paymentDetailEntryType,
        onChange: function onChange(e, val) {
          _this2.props.setFormValue('paymentDetailEntryType', 'orgDetails', val);
        },
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(RadioButton, {
        value: 1,
        label: "Entered by ".concat(newAffiliateName),
        style: {
          marginBottom: 12
        }
      }), /*#__PURE__*/React.createElement(RadioButton, {
        value: 2,
        label: "Entered by ".concat(partnerName)
      }))), /*#__PURE__*/React.createElement("section", {
        className: styles.formSection,
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Agreement Length"), /*#__PURE__*/React.createElement(SelectField, {
        floatingLabelText: "Number of Months",
        value: this.props.orgConfig.contractMonths,
        onChange: function onChange(e, index, value) {
          _this2.props.setFormValue('contractMonths', 'orgConfig', value);
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 1,
        primaryText: "Month to Month"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 2,
        primaryText: "2 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 3,
        primaryText: "3 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 4,
        primaryText: "4 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 5,
        primaryText: "5 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 6,
        primaryText: "6 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 7,
        primaryText: "7 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 8,
        primaryText: "8 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 9,
        primaryText: "9 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 10,
        primaryText: "10 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 11,
        primaryText: "11 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 12,
        primaryText: "12 Months"
      })))));
    }
  }]);

  return NewAffiliateFormStep1;
}(Component)) || _class);
export { NewAffiliateFormStep1 as default };